module.exports = __webpack_public_path__ + "img/89688e0.jpg";